import PropTypes from 'prop-types';

const currentUserPropTypes = {
  currentUser: PropTypes.shape({
    attributes: PropTypes.shape({
      given_name: PropTypes.string,
      family_name: PropTypes.string,
      address: PropTypes.string,
    }),
  }),
};

export default currentUserPropTypes;
